import { render, staticRenderFns } from "./TableLineSupplementaryDescriptionModal.vue?vue&type=template&id=bf9fbee0"
import script from "./TableLineSupplementaryDescriptionModal.vue?vue&type=script&lang=js"
export * from "./TableLineSupplementaryDescriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports